import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Table } from 'reactstrap';
import Panel from '../Panel';
import {
  getTableHeaderStyle,
  getTableRowStyle,
  getTableWrapperStyle,
  isDarkTheme,
} from '../../helpers/themeTableStyles';

const MetricLine = ({
  content, loadingData, lgWidth, data,
}) => {
  const theme = useSelector(store => store.theme);
  const isDarkMode = isDarkTheme(theme);

  return (
    <Panel lg={12} md={lgWidth} title={content.title} parentRefresh={loadingData}>
      <div style={getTableWrapperStyle(isDarkMode)}>
        <Table responsive className="table--bordered">
          <thead style={{ backgroundColor: isDarkMode ? '#232531' : '#f8f9fa' }}>
            <tr>
              <th style={getTableHeaderStyle(isDarkMode)}>{content.metricHeader}</th>
              <th style={{ ...getTableHeaderStyle(isDarkMode), textAlign: 'center' }}>{content.metricRangeOne}</th>
              <th style={{ ...getTableHeaderStyle(isDarkMode), textAlign: 'center' }}>{content.metricPerformanceHeader}</th>
              <th style={{ ...getTableHeaderStyle(isDarkMode), textAlign: 'center' }}>{content.metricRangeTwo}</th>
            </tr>
          </thead>
          <tbody>
            {data && data.map((line, index) => {
              const rowStyle = getTableRowStyle(isDarkMode, index % 2 === 1);
              return (
                <tr key={line.metric || index} style={rowStyle}>
                  <td style={rowStyle}>{line.metric}</td>
                  <td style={{ ...rowStyle, textAlign: 'center' }}>{line.rangeOne}</td>
                  <td style={{ ...rowStyle, textAlign: 'center' }}>{line.performance}</td>
                  <td style={{ ...rowStyle, textAlign: 'center' }}>{line.rangeTwo}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </Panel>
  );
};

MetricLine.defaultProps = {
  lgWidth: 6,
};

MetricLine.propTypes = {
  // eslint-disable-next-line
  content: PropTypes.object.isRequired,
  // eslint-disable-next-line
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadingData: PropTypes.bool.isRequired,
  lgWidth: PropTypes.number,
};

export default MetricLine;
